import { ROUTE_PATHS } from '../../routes/consts';
import { RoutePath } from '../../routes/types';
import { ITEM_ID } from '../Sidebar/consts';

/**
 * Mapping of route paths to their corresponding ITEM_IDs
 * Used for getting icons for breadcrumbs
 */
export const ROUTE_TO_ITEM_ID_MAP: Partial<
  Record<RoutePath, (typeof ITEM_ID)[keyof typeof ITEM_ID]>
> = {
  [ROUTE_PATHS.HOME]: ITEM_ID.HOME,
  [ROUTE_PATHS.MONITOR]: ITEM_ID.MONITOR,
  [ROUTE_PATHS.INTEGRATIONS]: ITEM_ID.INTEGRATIONS,
  [ROUTE_PATHS.RULES]: ITEM_ID.RULES,
  [ROUTE_PATHS.FINDINGS]: ITEM_ID.FINDINGS,
  [ROUTE_PATHS.TEAM_PROFILES]: ITEM_ID.TEAM_PROFILES,
  [ROUTE_PATHS.ANALYTICS]: ITEM_ID.ANALYTICS,
  [ROUTE_PATHS.CONFIGURATION]: ITEM_ID.CONFIGURATION,
  [ROUTE_PATHS.ORGANIZATION]: ITEM_ID.ORGANIZATION,
  [ROUTE_PATHS.TEAM]: ITEM_ID.TEAM,
  [ROUTE_PATHS.TEAMS_MANAGEMENT]: ITEM_ID.TEAMS_MANAGEMENT,
  [ROUTE_PATHS.MANAGEMENT_REPOSITORIES]: ITEM_ID.MANAGEMENT_REPOSITORIES,
  [ROUTE_PATHS.WIKI]: ITEM_ID.WIKI,
  [ROUTE_PATHS.SANDBOX_CONFIG]: ITEM_ID.SANDBOX_CONFIG,
};
